module.exports = __webpack_public_path__ + "img/9d3be38.svg";